// extracted by mini-css-extract-plugin
export default {"ContactDetailsExpand":"ContactDetailsForm_ContactDetailsExpand__4-ctN","expand":"ContactDetailsForm_expand__LfXq0"};